import { stdObject } from "../data/types/stdObject";
import { toPrice } from "../utils/toPrice";
import { sendData } from "./sendData";

export const callPaymentsInfo = async (
  modalInfo: stdObject,
  logoutAction: any,
) => {
  try {
    const payloadCallPayments = {
      type: modalInfo.type,
      doc: modalInfo.doc,
      serie: modalInfo.serie,
      code: modalInfo.code,
    };
    const responseCallPayments: stdObject = await sendData({
      endPoint: "callPayments",
      payload: payloadCallPayments,
      logoutAction,
    });

    if (responseCallPayments.success && responseCallPayments.status) {
      let tempData: stdObject = responseCallPayments.blocked
        ? {
            blocked: responseCallPayments.blocked,
            type: responseCallPayments.type,
          }
        : {
            info: responseCallPayments.info,
            type: responseCallPayments.type,
            BAL: responseCallPayments.info.TOT - responseCallPayments.info.ABO,
            PAY: 0,
            QTY:
              responseCallPayments.info.TOT - responseCallPayments.info.ABO > 0
                ? toPrice(
                    responseCallPayments.info.TOT -
                      responseCallPayments.info.ABO,
                  )
                : null,
            records: responseCallPayments.records,
          };

      return { data: tempData };
    } else {
      return { error: responseCallPayments.error };
    }
  } catch (error) {
    return { error: "error" };
  }
};
